import { render, staticRenderFns } from "./Edition.vue?vue&type=template&id=00bb93ab&scoped=true&"
import script from "./Edition.vue?vue&type=script&lang=ts&"
export * from "./Edition.vue?vue&type=script&lang=ts&"
import style0 from "./Edition.vue?vue&type=style&index=0&id=00bb93ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bb93ab",
  null
  
)

export default component.exports